define('app-TableCruise/main',['./settings'], function (settings) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                window.log('No "Cruise Table" Container found.  app-FaqsNew will not be available.');
                return;
            }
            var array = [];
            $('.bodyLink').each(function () {

                var newItem = $(this).attr('data-ship');
                array.indexOf(newItem) === -1 ? array.push(newItem) : console.log("This item already exists");

            });
            if (array.length > 1) {
                $('.table-tabs li').show();
                $('#table-select').css("display", "block");
                $.each(array, function (index, val) {
                    $('.table-tabs').append('<li><a data-tab="' + this + '">' + this + '</a></li>');
                    $('#table-select').append('<option value="' + this + '">' + this + '</option>');
                });
            }

            $(".table-tabs a").click(function () {
                $(".table-tabs a").removeClass('active');
                if ($(this).attr('data-tab') == 'showAll') {
                    $('.bodyLink').fadeIn(500);
                    $(this).addClass('active');
                    $("#table-select").val('showAll');
                }
                else {
                    var current = $(this).attr('data-tab');
                    $(".bodyLink").hide();
                    $(".bodyLink").each(function () {

                        if ($(this).attr('data-ship') == current) {
                            $(this).fadeIn(500);
                        }
                    });
                    $("#table-select").val(current);

                }
                $(this).addClass('active');

            });

            $("#table-select").change(function () {
                if ($(this).find(":selected").val() == 'showAll') {
                    $('.bodyLink').fadeIn(500);
                    $('.table-tabs a[data-tab="showAll"]').addClass('active');

                }
                else {
                    var current = $(this).find(":selected").val();
                    $(".bodyLink").hide();
                    $(".bodyLink").each(function () {

                        if ($(this).attr('data-ship') == current) {
                            $(this).fadeIn(500);
                        }
                    });
                    $('.table-tabs a').removeClass('active');
                    $(".table-tabs a[data-tab='" + current + "']").addClass('active');

                }
            });

            window.loadedModules("app-TableCruise");
        }
    }
});





